"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ConfirmModal = require("web/shared/components/ConfirmModal.styles");
var _InfoModal = require("web/shared/components/InfoModal.styles");
var _useEscapeToClose = _interopRequireDefault(require("web/shared/hooks/useEscapeToClose"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A small centered informational dialog: a title, some explanatory body, and a
* single dismiss button. Unlike ConfirmModal there is no destructive choice —
* it just explains or shows something and closes. It reuses ConfirmModal's
* modal chrome (backdrop, dialog card, Escape-to-close) so every dialog looks
* and behaves the same.
*
* The parent owns the open state; it renders nothing when closed. A body
* taller than the dialog's cap scrolls, and a hairline then divides it
* from the dismiss button, so the edge of what is scrollable is seen; a
* body that fits draws no line.
*/ // How long the exit animation runs before the modal unmounts (keep in sync
// with the overlayOut / dialogOut durations in InfoModal.styles).
const EXIT_MS = 190;
function InfoModal(_ref) {
  let open = _ref.open,
    title = _ref.title,
    children = _ref.children,
    closeLabel = _ref.closeLabel,
    accentClose = _ref.accentClose,
    wide = _ref.wide,
    onClose = _ref.onClose; // Keep the modal mounted through its exit animation: `mounted` stays true
  // until the fade-out finishes, and `closing` drives the exit styles.
  const _useState = (0, _react.useState)(open),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  const _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    closing = _useState4[0],
    setClosing = _useState4[1]; // The scrolling body, once rendered, and whether it has more than fits.
  const _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    body = _useState6[0],
    setBody = _useState6[1];
  const _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    overflows = _useState8[0],
    setOverflows = _useState8[1];
  (0, _react.useLayoutEffect)(() => {
    if (body == null) {
      return undefined;
    }
    const measure = () => {
      setOverflows(body.scrollHeight > body.clientHeight);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [body, children]);
  (0, _react.useEffect)(() => {
    if (open) {
      setMounted(true);
      setClosing(false);
      return undefined;
    }
    if (!mounted) {
      return undefined;
    }
    setClosing(true);
    const timer = setTimeout(() => {
      setMounted(false);
      setClosing(false);
    }, EXIT_MS);
    return () => clearTimeout(timer);
  }, [open, mounted]);
  (0, _useEscapeToClose.default)(open, onClose);
  if (!mounted) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConfirmModal.styles.overlay, closing && _InfoModal.styles.overlayOut)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)({
      type: "button",
      "aria-hidden": "true",
      tabIndex: -1,
      onClick: onClose
    }, stylex.props(_ConfirmModal.styles.backdrop))), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      role: "dialog",
      "aria-modal": "true",
      "aria-label": title
    }, stylex.props(_ConfirmModal.styles.dialog, _InfoModal.styles.dialogScroll, wide === true && _InfoModal.styles.dialogWide, closing && _InfoModal.styles.dialogOut)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConfirmModal.styles.title)), {}, {
        children: title
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        ref: setBody
      }, stylex.props(_ConfirmModal.styles.message, _InfoModal.styles.scrollBody, overflows && _InfoModal.styles.scrollBodyOverflowing)), {}, {
        children: children
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConfirmModal.styles.actions, overflows && _InfoModal.styles.actionsAfterScroll)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
          type: "button",
          onClick: onClose
        }, stylex.props(_ConfirmModal.styles.button, accentClose === true ? _InfoModal.styles.accentClose : _ConfirmModal.styles.cancel)), {}, {
          children: closeLabel
        }))
      }))]
    }))]
  }));
}
var _default = exports.default = InfoModal;